import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-distribution-init',
  templateUrl: './distribution-init.component.html',
  styleUrls: ['./distribution-init.component.css']
})
export class DistributionInitComponent implements OnInit {
  @Input() isVisible: boolean = false;
  @Output() closeDrawer: EventEmitter<void> = new EventEmitter<void>();
  @Output() initSuccess: EventEmitter<any> = new EventEmitter<any>();

  isTicketNumberEnabled: boolean = true; // FL_CFG_001

  // Tab đích đến: 'dealer' hoặc 'region'
  destinationType: string = 'dealer';

  formData: any = {
    dealer: '',
    routingType: 'routed',
    requireConfirm: false,
    name: '',
    ticketNumber: '',
    notes: '',
    expectedQty: null
  };

  // Khu vực (nhiều dòng)
  regions: any[] = [
    { province: '', district: '', address: '' }
  ];

  submitted: boolean = false;
  isSubmitting: boolean = false;

  // Image handling
  selectedImage: File | null = null;
  imagePreviewUrl: string | ArrayBuffer | null = null;
  imageError: string = '';

  // Mock data
  dealers: any[] = [
    { id: '1', name: 'Đại lý Hoàng Anh - TP.HCM' },
    { id: '2', name: 'Đại lý Minh Phát - Hà Nội' },
    { id: '3', name: 'Đại lý Thành Đạt - Đà Nẵng' },
    { id: '4', name: 'Đại lý Phú Quý - Cần Thơ' }
  ];

  provinces: any[] = [
    { id: '1', name: 'TP. Hồ Chí Minh' },
    { id: '2', name: 'Hà Nội' },
    { id: '3', name: 'Đà Nẵng' },
    { id: '4', name: 'Cần Thơ' },
    { id: '5', name: 'Bình Dương' }
  ];

  districts: any[] = [
    { id: '1', name: 'Quận 1' },
    { id: '2', name: 'Quận 2' },
    { id: '3', name: 'Quận 3' },
    { id: '4', name: 'Quận Bình Thạnh' },
    { id: '5', name: 'Quận Tân Bình' }
  ];

  constructor() { }

  ngOnInit(): void { }

  close() {
    this.closeDrawer.emit();
  }

  switchTab(tab: string) {
    this.destinationType = tab;
  }

  addRegion() {
    this.regions.push({ province: '', district: '', address: '' });
  }

  removeRegion(index: number) {
    if (this.regions.length > 1) {
      this.regions.splice(index, 1);
    }
  }

  onSubmit(form: any) {
    this.submitted = true;
    if (form.invalid) {
      return;
    }
    this.isSubmitting = true;
    setTimeout(() => {
      this.isSubmitting = false;
      this.initSuccess.emit(this.formData);
      this.resetForm();
    }, 1500);
  }

  resetForm() {
    this.submitted = false;
    this.isSubmitting = false;
    this.destinationType = 'dealer';
    this.formData = {
      dealer: '',
      routingType: 'routed',
      requireConfirm: false,
      name: '',
      ticketNumber: '',
      notes: '',
      expectedQty: null
    };
    this.regions = [{ province: '', district: '', address: '' }];
    this.selectedImage = null;
    this.imagePreviewUrl = null;
    this.imageError = '';
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    this.imageError = '';
    
    if (file) {
      // Validate file type
      if (!['image/jpeg', 'image/png'].includes(file.type)) {
        this.imageError = 'Chỉ hỗ trợ định dạng JPG/PNG.';
        this.selectedImage = null;
        this.imagePreviewUrl = null;
        return;
      }
      
      // Validate file size (5MB = 5 * 1024 * 1024 bytes)
      if (file.size > 5242880) {
        this.imageError = 'Kích thước file tối đa 5MB.';
        this.selectedImage = null;
        this.imagePreviewUrl = null;
        return;
      }

      this.selectedImage = file;
      
      // Create preview
      const reader = new FileReader();
      reader.onload = e => this.imagePreviewUrl = reader.result;
      reader.readAsDataURL(file);
    }
  }

  removeImage() {
    this.selectedImage = null;
    this.imagePreviewUrl = null;
    this.imageError = '';
  }

  getCharCount(value: string): number {
    return value ? value.length : 0;
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/distribution-init/distribution-init.component.ts